export enum DoorWidthEnum {
  Wide,
  Thin
}
